import navbarButtons from 'src/templates/navigationBar/buttons.hbs';
import progressBar from 'src/templates/navigationBar/progressBar.hbs';
import domSelector from 'src/utils/domSelector';
import flowStore from '../../stores/flowStore';

const PROGRESS_AT_START = 5;

/* destroyButtons() resets buttons in the navbar. */
const destroyButtons = () => {
  const navBarElements = domSelector.getNavbarButtons().children;
  Array.from(navBarElements).forEach((child) => child.remove());
};

/* appendButtons() is a function that will append button(s) to navigation
 * bar. There is 2 ways to configure or hide the button(s), through flow-level OR node-level options.
 * If there is 2 options defined, the flow-level will override the node-level options
 */
const appendButtons = (options = {}) => {
  destroyButtons();

  const container = document.createElement('div');
  domSelector.getNavbarButtons().appendChild(container);
  container.outerHTML = navbarButtons(options);
};

const updateProgressBar = () => {
  // Calculate the progress based on where we are in the flow.
  // If the value is zero because we are on the first node, default to a small percentage to show a bit of progress
  const progress = (flowStore.getActiveNode().id / (flowStore.getFlowLength() - 1)) * 100 || PROGRESS_AT_START;
  domSelector.getProgressBar().style.width = `${progress}%`;
};

const renderProgressBar = () => {
  const container = document.createElement('div');
  domSelector.getNavbar().appendChild(container);
  container.outerHTML = progressBar();
  updateProgressBar();
};

// Renders and updates the progress bar if the flow contains the showProgressBar option
const updateProgress = (options = {}) => {
  if (options.showProgressBar) {
    const progressBar = domSelector.getProgressBar();
    progressBar ? updateProgressBar() : renderProgressBar();
  }
};

export default { appendButtons, updateProgress };
